export default function DeleteButton(props) {
  return (
    <input className="box button is-danger" type="button" value={props.value} onClick={props.click}/>
  )
}